// #region Base URL Configuration
export const base_url = window.APP_CONFIG?.BASE_URL || "https://localhost:7229";
// #endregion

// export const ExportPdfUrl = 'http://pdfgenerator.msisolutions.co.uk/form';
export const ExportPdfUrl = "http://localhost:5000/form";

export const GetkeycloackConnectionInformationfUrl = base_url + "/api/User/GetkeycloackConnectionInformation";
export const RedirectUri = window.location.origin;

export const LoginEndPoint = base_url + "/api/User/Login";

export const GetGisTokenData = base_url + "/api/Integration/GetGisToken";

export const CurrentWorkflowStep = "currentWorkflowStep";
export const HasRedirected = "hasRedirected";

export const GetLoggedInUserData = base_url + "/api/User/GetLoggedInUserData/";

export const SendContactMessage = base_url + "/api/User/SendContactMessage/";


export const GetAllRolesDTOEndPoint = base_url + "/api/Role/GetAllRolesDTO/";

export const DeleteCompanyRolesData = base_url + "/api/Role/DeleteRoles";




export const SelectedCompany = "selectedCompany";
export const SelectedKeycloakCompany = "selectedKeycloakCompany";






export const GetCRInformationByCRNumberData = base_url + "/api/Integration/GetCRInformationByCRNumber/";
export const GetCompaniesByType = base_url + "/api/Company/GetCompaniesByType/";
export const CreateCompanyEndPoint = base_url + "/api/Company/CreateCompany";

export const SendOtpEndPoint = base_url + "/api/User/SendOtp";

export const GetAllUsersEndPoint = base_url + "/api/User/GetAllUsers";
export const GetUserEndPoint = base_url + "/api/User/GetUser/#ID#";
export const CreateUserEndPoint = base_url + "/api/User/CreateUser";
export const CreateSubmissionEndPoint = base_url + "/api/Forms/createSubmission";

export const DeleteUserEndPoint = base_url + "/api/User/DeleteUser/#ID#";
export const UpdatePasswordEndPoint = base_url + "/api/User/UpdatePassword/";
export const UpdateForgottenPasswordEndPoint = base_url + "/api/User/ChangeForgottenPassword";
export const ForgotPasswordRequestEndPoint = base_url + "/api/User/ForgotPasswordRequest";
export const EditUserWithoutIdEndPoint = base_url + "/api/User/EditUser";
export const GetUserCompanyByEmailEndpoint = base_url + "/api/DataBase/GetCompanyByUserEmail";

export const GetAllGroupsEndPoint = base_url + "/api/group/GetAllGroups";
export const GetAllUsersInAGroupEndPoint = base_url + "/api/group/GetAllUsersInGroup/#GroupID#";
export const GetAllGroupsByUser = base_url + "/api/group/GetAllGroupsByUser/#UserID#";
export const CreateGroupEndPoint = base_url + "/api/group/CreateGroup";

export const CompaniesGroupID = "bd062c6f-3474-4378-abc4-81346054d1ab";

export const GetAllRolesEndPoint = base_url + "/api/Role/GetAllRoles?briefRepresentation=false";
export const CreateRoleEndPoint = base_url + "/api/Role/CreateRole";
export const EditRoleEndPoint = base_url + "/api/Role/EditRole";
export const AssignRolesUsersEndPoint = base_url + "/api/Role/AssignRolesUsers";
export const UnassignRolesFromUserEndPoint = base_url + "/api/Role/UnassignRolesFromUser";
export const DeleteRoleEndPoint = base_url + "/api/Role/DeleteRole";
export const UserRolesEndPoint = base_url + "/api/Role/GetUserRoles/#ID#";

export const GetExecutionLocalVariableEndPoint = base_url + "/api/Workflow/GetExecutionLocalVariables";

export const GetWorkflowListByAssigneeEndPoint = base_url + "/api/Workflow/GetAllWorkflowsByAssignee/";


export const GetWorkflowListByGroupsEndPoint = base_url + "/api/Workflow/GetAllWorkflowsByGroups/";
export const GetWorkflowListByUsersEndPoint = base_url + "/api/Workflow/GetAllWorkflowsByUsers/";

export const GetWorkflowsHistoryByProcessInstance = base_url + "/api/Workflow/GetWorkflowsHistoryByProcessInstance/";

export const GetWorkflowsSubprocessEndPoint = base_url + "/api/Workflow/GetWorkflowsSubprocess/";
export const GetTaskEndPoint = base_url + "/api/Workflow/GetUserTask/";

export const VerificationEmailProcessDefinitionKey = "verification_workflow";
export const GetAllWorflowsEndpoint = base_url + "/api/Workflow/GetAllWorkflows/";
export const DeleteWorkflowEndPoint = base_url + "/api/Workflow/DeleteDeployment/";
export const UploadWorkflowEndPoint = base_url + "/api/Workflow/UploadAllWorkflows/";
export const CompleteTaskEndPoint = base_url + "/api/Workflow/CompleteTask/";
export const GetExternalServiceTaskEndPoint = base_url + "/api/Workflow/GetExternalTask/";
export const FetchAndLockEndPoint = base_url + "/api/Workflow/FetchAndLockExternalTask/";
export const CompleteExternalTaskEndPoint = base_url + "/api/Workflow/CompleteExternalTask/";
export const GetWorkflowDiagramEndPoint = base_url + "/api/Workflow/GetDiagram/";

export const GetCountWorkflowsByGroupsEndPoint = base_url + "/api/workflow/GetCountWorkflowsByGroups/";
export const GetCountWorkflowsByUsersEndPoint = base_url + "/api/workflow/GetCountWorkflowsByUsers/";

export const VerifyEmailValidityEndPoint = base_url + "/api/DataBase/verify-email-validity";


export const ModifyProcessInstanceVariableEndPoint = base_url + "/api/Workflow/ModifyProcessInstanceVariable";


export const GetCountTaskByAssigneeEndPoint = base_url + "/api/Workflow/GetCountTaskByAssignee/";
export const GetCountUnAssignedTaskEndPoint = base_url + "/api/Workflow/GetCountUnAssignedTask/";


export const GetRenderEndPoint = base_url + "/api/Template/GetRender";




export const GetFormByPathEndPoint = base_url + "/api/Forms/getFormbyPath/#FORMPATH#";
export const CreateFormEndPoint = base_url + "/api/Forms/createForm";

export const DeleteFormEndPoint = base_url + "/api/Forms/deleteForm/#FORMPATH#";
export const GetAllSubmissionsEndPoint = base_url + "/api/Forms/form/#FORMID#/submission";
export const GetAllSubmissionByIdEndPoint = base_url + "/api/Forms/getForms";

export const SendNotificationEndPoint = base_url + "/api/Notifications/send-notification";

export const SendSmsEndPoint = base_url + "/api/Integration/SendSmsMessage";




export const GetMenu = base_url + "/api/User/GetMenu/";

export const GetAllResourcesEndPoint = base_url + "/api/DataBase/GetAllResources";
export const DeleteDBRecordEndPoint = base_url + "/api/DataBase/DeleteRecordDTO/";

export const CompanyTypesTableName = "companytype";
export const CompaniesTableName = "company";
export const LanguageTableName = "Languages";
export const SiteMapsTableName = "Menu";
export const SystemPropertiesTableName = "system_properties";
export const LabelsTableName = "Labels";

export const AccessTokenKeyInLocalStorage = "accessToken";
export const RefreshTokenKeyInLocalStorage = "refreshToken";
export const LoggedInEmailOrUserNameKeyInLocalStorage = "loggedInEmailOrUserName";
export const LoggedInRolesAttributesKeyInLocalStorage = "loggedInRolesAttributes";
export const LoggedInUserInfoKeyInLocalStorage = "loggedInUserInfo";

export const platform = "platform";

export var RoleAttributes = [
	{ id: "Dashboards", name: "Dashboards", checked: false },
	{ id: "Users", name: "Users", checked: false },
	{ id: "Roles", name: "Roles", checked: false },
	{ id: "Forms", name: "Forms", checked: false },
	{ id: "Workflows", name: "Workflows", checked: false },
];
export const RegistrationProcessDefinitionKey = "registration_workflow";
export const TestProcessDefinitionKey = "service_process";

export const SuccessStatus = 1;
export const FailureStatus = 0;
export const LogoutStatus = -1;

export var Language = "en";
export const FormLanguages = [
	{
		label: "English",
		value: "en",
		translation: {
			en: "English",
			ar: "الانكليزية",
			fr: "Anglais",
		},
	},
	{
		label: "Arabic",
		value: "ar",
		translation: {
			en: "Arabic",
			ar: "العربية",
			fr: "Arabe",
		},
	},
	// {
	//     label: "French",
	//     value: "fr",
	//     translation: {
	//         en: "French",
	//         ar: "الفرنسية",
	//         fr: "Francais"
	//     }
	// },
];

export const VerifyEmailEndPoint = base_url + "/api/DataBase/verify-email";


// #region PUBLIC
export const GetPublicMenuData = base_url + "/api/public/menu";
export const GetDomainDataEndPoint = base_url + "/api/public/domain";
export const GetLabelsData = base_url + "/api/public/labels";
export const GetServicesData = base_url + "/api/public/services";
export const GetUserManualsData = base_url + "/api/public/user-manuals";
// #endregion

// #region DATABASE
export const GetEndPoint = base_url + "/api/Supabase/single";
export const GetAllEndPoint = base_url + "/api/Supabase/all";
export const PatchEndPoint = base_url + "/api/Supabase";
export const PutEndPoint = base_url + "/api/Supabase";
export const PostEndPoint = base_url + "/api/Supabase";
export const DeleteDBEndPoint = base_url + "/api/Supabase";
// #endregion

// #region COMPANIES
export const GetCompanyRolesData = base_url + "/api/Companies/roles";
export const GetUserCompaniesData = base_url + "/api/Companies/user";
export const GetBranchesCompanyEndPoint = base_url + "/api/Companies/branches";
export const ImportUserData = base_url + "/api/Companies/import";
// #endregion

// #region ROLES
export const UpdateUserRolesData = base_url + "/api/Roles/update-user-roles";
export const getUserRolesData = base_url + "/api/Roles/system";
// #endregion

// #region USERS
export const GetLoggedInUserAccessData = base_url + "/api/Users/access-data";
export const GetCompanyUsersData = base_url + "/api/Users/company/data";
export const AddUserData = base_url + "/api/Users/company";
export const UnassignUserData = base_url + "/api/Users";
export const EditUserEndPoint = base_url + "/api/Users";
// #endregion

// #region GENERATORS
export const GetTransporterGeneratorsData = base_url + "/api/WasteManagement/generators";
export const DeleteTransporterGeneratorData = base_url + "/api/WasteManagement/generators";
export const AddTransporterGeneratorData = base_url + "/api/WasteManagement/generators";
export const EditTransporterGeneratorsData = base_url + "/api/WasteManagement/generators";
// #endregion

// #region CONTACTS/DELEGATES
export const AddTransporterContactData = base_url + "/api/WasteManagement/contacts";
export const EditTransporterContactData = base_url + "/api/WasteManagement/contacts";
export const DeleteTransporterContactData = base_url + "/api/WasteManagement/contacts";
export const GetTransporterContactsData = base_url + "/api/WasteManagement/contacts";
// #endregion

// #region TRUCKS
export const GetTransporterTrucksData = base_url + "/api/WasteManagement/trucks";
export const AddTransporterTruckData = base_url + "/api/WasteManagement/trucks";
export const DeleteTransporterTruckData = base_url + "/api/WasteManagement/trucks";
export const EditTransporterTruckData = base_url + "/api/WasteManagement/trucks";
// #endregion

// #region MOC
export const GetCRDetails = base_url + "/api/Integration/cr/details";
// #endregion

// #region TEMPLATES
export const GetAllTemplatesEndPoint = base_url + "/api/Templates/all";
export const DownloadTemplateEndPoint = base_url + "/api/Templates/download";
export const AddTemplateEndPoint = base_url + "/api/Templates/create";
export const DeleteTemplateEndPoint = base_url + "/api/Templates";
// #endregion

// #region FORMS
export const GetFormByIdEndPoint = base_url + "/api/Forms/form/";
export const EditFormEndPoint = base_url + "/api/Forms/editForm/";
export const GetAllFormsEndPoint = base_url + "/api/Forms/getForms";
// #endregion

// #region WORKFLOWS
export const DeleteProcessInstance = base_url + "/api/Workflow/DeleteProcessInstance";
export const GetWorkflowsEndpoint = base_url + "/api/Workflow/GetWorkflows";
export const GetTaskVariables = base_url + "/api/Workflow/GetTaskVariables";
export const cloneWorkflow = base_url + "/api/Workflow/CloneWorkflow";
export const PostregeneratePDF = base_url + "/api/Workflow/RegeneratePDF";
export const GetFormByUserTaskEndPoint = base_url + "/api/Workflow/GetFormByUserTask";
export const setAssignEndPoint = base_url + "/api/Workflow/SetAssignee";
export const PutProcessInstanceVariableEndPoint = base_url + "/api/Workflow/PutProcessInstanceVariable";
export const UnclaimTaskEndPoint = base_url + "/api/Workflow/UnClaimTask";
export const ClaimTaskEndPoint = base_url + "/api/Workflow/ClaimTask";
export const StartProcessByDefinitionKeyEndPoint = base_url + "/api/Workflow/StartProcessByDefinitionKey";
export const GetPendingTasksEndPoint = base_url + "/api/Workflow/PendingTasks";
export const GetWorkflowListHistoryByAssigneeEndPoint = base_url + "/api/Workflow/WorkflowHistory";
export const StartProcessEndPoint = base_url + "/api/Workflow/StartProcess";
export const SubmitWorkflowEndPoint = base_url + "/api/Workflow/SubmitWorkflow";
// #endregion

// #region DASHBOARDS
export const GetSupersetDashboardEndPoint = base_url + "/api/Dashboards/superset/get-dashboards";
// #endregion
